// Drawola: which collaboration guide a page language links to. Fork-only.
//
// Callers pass the language the page shows right now, never a second browser
// detection and never a language that is still loading.

/**
 * App languages with a guide in that language. manual/guide.test.ts checks
 * this list against the production language registry.
 */
const GUIDE_LOCALES: readonly string[] = [
  "en",
  "ar-SA",
  "de-DE",
  "es-ES",
  "eu-ES",
  "fr-FR",
  "he-IL",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "nl-NL",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "sk-SK",
  "sv-SE",
  "tr-TR",
  "uk-UA",
  "zh-CN",
  "zh-TW",
];

/** Guides written by hand in public/manual/; the others are generated. */
export const HAND_WRITTEN_GUIDE_LOCALES: readonly string[] = ["zh-TW"];

/** Real guide pages, keyed by app language code. */
export const COLLABORATION_GUIDES: Readonly<Record<string, string>> =
  Object.freeze(
    Object.fromEntries(
      GUIDE_LOCALES.map((code) => [code, `/manual/collaboration-${code}.html`]),
    ),
  );

/** Whether `code` has a collaboration guide written in that language. */
export const hasCollaborationGuide = (code: string): boolean =>
  Object.prototype.hasOwnProperty.call(COLLABORATION_GUIDES, code);

/**
 * The guide link for the language the page shows, or null for a code with no
 * guide of its own, such as an unknown or malformed one. Callers then show no
 * guide link at all, so a page never links a guide in another language.
 */
export const collaborationGuideHref = (displayedCode: string): string | null =>
  hasCollaborationGuide(displayedCode)
    ? COLLABORATION_GUIDES[displayedCode]
    : null;
